<div class="sx-help-contextual-info" *ngIf="contextualInfoDisplay">
  <div *ngFor="let contextualInfo of contextualInfoDisplay">
    <div class="sx-help-contextual-info__title">
      {{ contextualInfo.title }}
    </div>

    <div appRouterLink *ngIf="contextualInfo.description" class="sx-help-contextual-info__description" [innerHtml]="contextualInfo.description | safeHtml">
    </div>
  </div>
</div>